// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"428":"68878b7d","581":"f11f54ba"}[chunkId] + ".chunk.js";
};